<template>
    <div :class="[companyClass , canScroll]">
        <div class="page-mobilemoneyprovider flex column mb-20">
                <div class="page-header">
                    <h1 class="pageTitle">{{pageTitle}}</h1>
                    <h4>{{pageSubtitle}} </h4>
                    <el-breadcrumb separator="/">
                        <el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
                        <el-breadcrumb-item>settings</el-breadcrumb-item>
                        <el-breadcrumb-item>transaction rules</el-breadcrumb-item>
                        <el-breadcrumb-item>add transaction rule</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>

                <div class="mt-0 w-100">
                    <div style="float: right;">
                        <el-button v-show="canDelete && userPermissionsFilter.addtransactionrule" 
                        type="primary" icon="el-icon-plus" @click="handleNew">
                        </el-button>

                        <el-button v-show="userPermissionsFilter.viewtransactionrule" type="warning" icon="el-icon-tickets"
                            @click="handleExit" title="view list"></el-button>

                        <el-button type="primary"
                        @click="validateAndSave" v-show="canSaveChanges" :disabled="!saveChanges">
                        <i class="mdi mdi-content-save"></i></el-button>
                    </div>
                </div>

                <div class="mt-10">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <span>Company</span><span :class="required"> *</span>
                            <el-select v-model="transactionRule.serviceProviderID" filterable clearable style="width:100%"
                            placeholder="Select company" :disabled="readOnlyMode"
                            name="company" v-validate="'required'" data-vv-as="" @change="companyChanged">
                                <el-option
                                v-for="item in companyNames"
                                :key="item.id"
                                :label="item.name" 
                                :value="item.id">
                                </el-option>
                            </el-select>
                            <transition name="fade">
                                <span class="danger-text">{{ errors.first('company') }}</span>
                            </transition>
                        </el-col>
                        <el-col :span="12">
                            <span>Corridor</span><span :class="required"> *</span>
                            <el-select v-model="transactionRule.countryID" filterable clearable style="width:100%"
                            placeholder="Select country" :disabled="readOnlyMode"
                            name="country" v-validate="'required'" data-vv-as="country" @change="countryChanged">
                                <el-option
                                v-for="item in countries"
                                :key="item.id"
                                :label="item.name" 
                                :value="item.id">
                                </el-option>
                            </el-select>
                            <transition name="fade">
                                <span class="danger-text">{{ errors.first('country') }}</span>
                            </transition>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" class="mt-10">
                        <el-col :span="12">
                                <span class="primary-text">Service Type</span><span :class="required"> *</span>
                                <el-select v-model="transactionRule.serviceTypeID" filterable clearable  style="width:100%"
                                placeholder="Select service type" :disabled="readOnlyMode"
                                name="servicetype" v-validate="'required'" data-vv-as="service type" @change="serviceTypeChanged">
                                    <el-option
                                    v-for="item in countryServices"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                    </el-option>
                                </el-select>
                                <transition name="fade">
                                    <span class="danger-text">{{ errors.first('servicetype') }}</span>
                                </transition>
                        </el-col>
                        <el-col :span="12">
                                <span class="primary-text">Frequency</span><span :class="required"> *</span>
                                <el-select v-model="transactionRule.frequency" filterable clearable  style="width:100%"
                                placeholder="Select rule frequency" :disabled="readOnlyMode"
                                name="frequency" v-validate="'required'" data-vv-as="frequency">
                                    <el-option
                                    v-for="frequency in frequencies"
                                    :key="frequency"
                                    :label="frequency"
                                    :value="frequency">
                                    </el-option>
                                </el-select>
                                <transition name="fade">
                                    <span class="danger-text">{{ errors.first('frequency') }}</span>
                                </transition>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20" class="mt-10" v-if="showDate">
                        <el-col :span="12">
                            <span class="primary-text">From Date</span><span></span>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-date-picker style="width:100%"
                                    v-model="fromDate"
                                    type="date"
                                    placeholder="From day">
                                    </el-date-picker>
                                </el-col>
                                <el-col :span="12">
                                    <el-time-picker style="width:100%"
                                        v-model="fromTime"
                                        placeholder="From time">
                                    </el-time-picker>
                                </el-col>
                            </el-row>
                        </el-col>
                        <el-col :span="12">
                            <span class="primary-text">To Date</span><span></span>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-date-picker style="width:100%"
                                    v-model="fromDate"
                                    type="date"
                                    placeholder="From day">
                                    </el-date-picker>
                                </el-col>
                                <el-col :span="12">
                                    <el-time-picker style="width:100%"
                                        v-model="fromTime"
                                        placeholder="From time">
                                    </el-time-picker>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" class="mt-10" v-else-if="transactionRule.frequency === 'Daily'">
                        <el-col :span="24">
                            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">Check all</el-checkbox>
                            <div style="margin: 15px 0;"></div>
                            <el-checkbox-group v-model="transactionRule.doWs" @change="handleCheckedDOWChange">
                                <el-checkbox v-for="dow in dows" :label="dow" :key="dow">{{dow}}</el-checkbox>
                            </el-checkbox-group>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" class="mt-10" v-else-if="transactionRule.frequency === 'Weekly'">
                        <el-col :span="12">
                            <span class="primary-text">Weeks</span>
                            <el-select v-model="transactionRule.weeks" filterable clearable multiple style="width:100%"
                            placeholder="Select Weeks">
                                <el-option
                                v-for="wk in weeks"
                                :key="wk"
                                :label="wk"
                                :value="wk">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" class="mt-10" v-else-if="transactionRule.frequency === 'Monthly'">
                        <el-col :span="12">
                            <span class="primary-text">Months</span>
                            <el-select v-model="transactionRule.months" filterable clearable multiple style="width:100%"
                            placeholder="Select Months">
                                <el-option
                                v-for="mnth in months"
                                :key="mnth"
                                :label="mnth"
                                :value="mnth">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" class="mt-10" v-else-if="transactionRule.frequency === 'Quartely'">
                        <el-col :span="24">
                            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllQuatersChange">Check all</el-checkbox>
                            <div style="margin: 15px 0;"></div>
                            <el-checkbox-group v-model="transactionRule.quaters" @change="handleCheckedQuaterChange">
                                <el-checkbox v-for="qtr in quaters" :label="qtr" :key="qtr">{{qtr}}</el-checkbox>
                            </el-checkbox-group>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" class="mt-10" v-else-if="transactionRule.frequency === 'Yearly'">
                        <el-col :span="12">
                            <span class="primary-text">Years</span>
                             <el-select v-model="transactionRule.years" filterable clearable multiple style="width:100%"
                            placeholder="Select Years">
                                <el-option
                                v-for="yr in years"
                                :key="yr"
                                :label="yr"
                                :value="yr">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20" class="mt-10">
                        <el-col :span="12">
                            <span class="primary-text">Scope</span><span :class="required"> *</span>
                            <el-radio-group v-model="transactionRule.scopeStr" style="width:100%">
                                <el-radio-button label="Raising" ></el-radio-button>
                                <el-radio-button label="Terminating"></el-radio-button>
                                <el-radio-button label="Both"></el-radio-button>
                            </el-radio-group>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20" class="mt-10">
                        <el-col :span="12">
                                <span class="primary-text">From Amount</span><span :class="required"> *</span>
                                <el-input v-model="transactionRule.fromAmount"
                                name="fromamount" v-validate="'required|numeric'" data-vv-as="from amount"
                                :readonly="readOnlyMode" @blur="propertyChanged"></el-input>
                                <transition name="fade">
                                    <span class="danger-text">{{ errors.first('fromamount') }}</span>
                                </transition>
                        </el-col>
                        <el-col :span="12">
                                <span class="primary-text">To Amount</span><span :class="required"> *</span>
                                <el-input v-model="transactionRule.toAmount" :readonly="readOnlyMode"
                                name="toamount" v-validate="'required|numeric'" data-vv-as="to amount" @blur="propertyChanged"></el-input>
                                <transition name="fade">
                                    <span class="danger-text">{{ errors.first('toamount') }}</span>
                                </transition>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20" class="mt-10">
                        <el-col :span="12">
                            <span>Activate Notifications</span>
                            <el-checkbox class="w-100" v-model="transactionRule.notificationActive" border>Send a notification on expiring</el-checkbox>
                        </el-col>
                        <el-col :span="6" v-show="transactionRule.notificationActive">
                            <span>Timespan before expiring</span>
                            <el-input placeholder="Timespan" v-model="transactionRule.timespan"></el-input>
                        </el-col>
                        <el-col :span="6" v-show="transactionRule.notificationActive">
                            <span>Timespan Type</span>
                            <el-select v-model="transactionRule.timeSpanType" filterable clearable placeholder="Timespan Type" class="mb-10" 
                            style="width:100%">
                                <el-option
                                v-for="tframe in timeframes"
                                :key="tframe.value"
                                :label="tframe.label"
                                :value="tframe.value">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" class="mt-10" v-show="transactionRule.notificationActive">
                        <el-col :span="12">
                            <span>Mobile Number Alerts</span>
                            <el-input v-model="transactionRule.notificationPhoneNumbers" type="textarea" :rows="2" placeholder="Enter mobile number separated by a comma"></el-input>
                        </el-col>
                        <el-col :span="12">
                            <span>Email Alerts</span>
                            <el-input v-model="transactionRule.notificationEmails" type="textarea" :rows="2" placeholder="Enter email addresses separated by a comma"></el-input>
                        </el-col>
                    </el-row>

                    <div class="mt-10">
                    	<el-button type="primary" icon="mdi mdi-content-save-outline"
                            @click="validateAndSave" :disabled="!canSaveChanges"> Save</el-button>
                    	<el-button type="danger" icon="mdi mdi-cancel" @click="cancelSave"> Cancel</el-button>
                	</div>
                </div>
        </div>
    </div>
</template>

<script>
import PermissionsMixins from '@/mixins/PermissionsMixins'
import router from '@/router/' 
import { bus } from '@/main'
import { Validator } from 'vee-validate'

export default {
    name: 'AddTransactionRule',
    data() {
        return {
            fromTime: '',
            toTime: '',
            canDelete: false,
            fromDate: null,
            fromTime: null,
            toDate: null,
            toTime: null,
            isIndeterminate: true,
            checkAll: false,
            frequencies: [],
            dows: [],
            quaters: [],
            months: [],
            transactionRule: {
                id: 0,
                countryID: '',
                serviceTypeID: '',
                frequency: '',
                fromAmount: 0,
                toAmount: 0,
                doWs: [],
                weeks: [],
                months: [],
                quaters: [],
                years: [],
                serviceProviderID: '',
                scopeStr: 'Raising',
                notificationActive: false,
                timespan: 0,
                timeSpanType: '',
                notificationPhoneNumbers: '',
                notificationEmails: ''
            }
        }
    },
    computed: {
        canSaveChanges() {
            return !this.readOnlyMode;
        },
        readOnlyMode() {
            return !(this.userPermissionsFilter.addtransactionrule 
            || this.userPermissionsFilter.edittransactionrule);
        },
        showDate() {
            let fx = this.transactionRule.frequency;
            return (fx === 'Date Range')
        },
        weeks() {
            return [...Array(51).keys()].map(p=> p+=1);
        },
        years() {
            var currentYear = new Date().getFullYear();
            var years = [];
            var endYear = new Date().getFullYear() + 50;

            for (var i = currentYear; i <= endYear; i++) {
                    years.push(i);
            } 

            return years;
        }
    },
    methods: {
        countryChanged() {
            this.propertyChanged();
            this.getCountriesServices(this.transactionRule.countryID);
        },
        companyChanged() {
            this.propertyChanged();
            this.transactionRule.countryID = '';
            //get company corridors
        },
        serviceTypeChanged() {
            this.propertyChanged();
            if(this.transactionRule.countryID && this.transactionRule.serviceTypeID){
                this.getCompanyNamesByServiceType(this.transactionRule.countryID, 
                this.transactionRule.serviceTypeID);
            }
        },
        resetPage() {
            this.fromTime = 0;
            this.toTime = 0;
            this.transactionRule.id = 0;
            this.transactionRule.countryID = '';
            this.transactionRule.serviceTypeID = '';
            this.transactionRule.fromAmount = 0;
            this.transactionRule.toAmount = 0;
            this.transactionRule.serviceProviderID = '';
            this.transactionRule.scopeStr = 'Raising';
            this.transactionRule.frequency = '';
            this.transactionRule.doWs = [];
            this.transactionRule.weeks = [];
            this.transactionRule.months = [];
            this.transactionRule.quaters = [];
            this.transactionRule.years = [];
            this.transactionRule.notificationActive = false;
            this.transactionRule.timespan = 0;
            this.transactionRule.timeSpanType = '';
            this.transactionRule.notificationPhoneNumbers = '';
            this.transactionRule.notificationEmails = '';
            this.$validator.reset();
        },
        handleCheckAllChange(val) {
            this.transactionRule.doWs = val ? this.dows : [];
            this.isIndeterminate = false;
        },
        handleCheckedDOWChange(value) {
            let checkedCount = this.transactionRule.doWs.length;
            this.checkAll = checkedCount === this.dows.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.dows.length;
        },
        handleCheckAllQuatersChange(val) {
            this.transactionRule.quaters = val ? this.quaters : [];
            this.isIndeterminate = false;
        },
        handleCheckedQuaterChange(value) {
            let checkedCount = this.transactionRule.quaters.length;
            this.checkAll = checkedCount === this.quaters.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.quaters.length;
        },
        createNew() {
            router.push('/addtransactionrule');
            this.resetPage();
        },
        saveRule() {
            this.saveTransactionRule(this.transactionRule)
            .then(result=> {
                if(result.id > 0){
                    this.transactionRule = result;
                    this.successMessage('Successfully saved transaction rule');
                    this.entitySaved();
                }
                else{
                    this.errorMessage('Failed to save transaction rule');
                }
            })
            .catch(err=> this.errorMessage('An error occurred'));
        },
        cancelSave() {
            this.resetPage();
        },
        viewTransactionRules() {
            router.push('/transactionrules')
        },
        validateAndSave() {
            var self = this;
            this.$validator.validateAll()
            .then(result=> {
                if(result)
                    self.saveRule();
                else
                    console.log('missing fields')
            });
        }
    },
    created() {
        this.newEvent = 'createNew';
        this.saveEvent = 'validateAndSave';
        this.exitEvent = 'viewTransactionRules';
        this.$on(this.saveEvent, this.validateAndSave);
        this.$on(this.newEvent, this.createNew);
        this.$on(this.exitEvent, this.viewTransactionRules);

        this.getCountries();
        this.getCompanyNames();
        var id = router.currentRoute.params.id;

		this.pageTitle = 'Add Transaction Rule';
		this.pageSubtitle = 'create transaction rule';

        if(id){
            this.canDelete = true;
            this.pageTitle = 'update transaction rule info';
            this.findTransactionRuleByID(id)
         	.then(result=> {
             this.transactionRule = result;
             this.countryChanged();
             this.serviceTypeChanged();
             this.pageSubtitle = `update ${result.countryName} ${result.serviceTypeName}'s transaction rule info`;
         });
        }
    },
    mounted() {
        this.resetPage();

        if(router.currentRoute.name === 'updatetransactionrule') {
            this.findTransactionRuleByID(router.currentRoute.id)
            .then(result=> this.transactionRule = result)
            .catch(err=> console.log(err));
        }

        
        this.getRuleFrequencies()
        .then(result=> {
            this.frequencies = result;
        });
        this.getDOW()
        .then(result=> this.dows = result);
        this.getQuaters()
        .then(result=> this.quaters = result);
        this.getMonths()
        .then(result=> this.months = result);
    },
    mixins: [PermissionsMixins]
}
</script>


<style lang="scss" scoped>

</style>

